/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-array-index-key */
import {
  Badge,
  Checkbox,
  createStyles,
  IconButton,
  ListItem,
  makeStyles,
  Theme,
  Typography,
  InputBase
} from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import React, { useRef, useState } from "react";
import { SearchIcon } from "../../icons/search";
import ClearIcon from "@material-ui/icons/Clear";

const CLFStyles = makeStyles((theme: Theme) =>
  createStyles({
    filterContainer: {
      width: "100%"
    },
    filterHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderTop: "1px solid #e9ecef",
      borderBottom: "1px solid #e9ecef",
      minHeight: "53px"
    },
    search: {
      position: "relative",
      width: "290px",

      "& .svg-icon": {
        fontSize: "16px"
      }
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1
    },
    clearIcon: {
      position: "relative",
      top: "8px",
      left: "-25px",
      cursor: "pointer"
    },
    inputRoot: {
      color: "inherit",
      width: "100%"
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: "36px",
      width: "100%",
      backgroundColor: "#f7fafc",
      border: "1px solid #e9ecef",
      borderRadius: "20px !important",
      fontSize: "12px"
    },
    filterHeaderText: {
      padding: "0px 10px 0px 14px",
      fontSize: "12px",
      fontWeight: 600,
      color: "#32325d"
    },
    iconStyles: {
      width: "16px",
      height: "16px"
    },
    categoryBlock: {
      // maxHeight: "150px",
      [theme.breakpoints.up("lg")]: {
        maxHeight: "250px"
      },
      [theme.breakpoints.down("lg")]: {
        maxHeight: "150px"
      },
      overflowY: "auto",
      overflowX: "hidden",
      transition: "max-height 0.5s"
    },
    filterTerms: {
      fontSize: "12px",
      fontWeight: "normal",
      color: "#32325d",
      padding: "0px"
    },
    checkListItem: {
      padding: "12px 20px",
      alignItems: "flex-start",
      borderBottom: "1px solid #e9ecef"
      // backgroundColor: "#f6f9fc"
    },
    scenarioCheckListItem: {
      padding: "12px",
      alignItems: "flex-start",
      borderBottom: "1px solid #e9ecef",
      backgroundColor: "#f6f9fc"
    },
    filterOutterContainer: {
      // minWidth: "330px",
      // maxWidth: "650px",
      backgroundColor: "#ffffff"
    }
  })
);

export interface CheckListItemProps {
  docCount?: number;
  label: string;
  value: string;
  checked: boolean;
  type?: string;
  checkBoxDataTestId?: string;
  onCheck: (...args: any[]) => void;
  onCheckArgs?: any[];
  onSearchInput?: any;
  listItemsStyle?: any;
}

export const CheckListItem = (props: CheckListItemProps) => {
  const checkBoxRef = useRef<HTMLButtonElement>(null);
  const {
    onCheck,
    onCheckArgs,
    label,
    value,
    type,
    checked,
    docCount,
    checkBoxDataTestId,
    onSearchInput,
    listItemsStyle
  } = props;
  const [searchVal, setSearchVal] = useState<string>("");
  const classes = CLFStyles();
  const itemClicked = (event: any, isParent: boolean = false) => {
    const eevent: any = event;
    eevent.stopPropagation();
    let checkBoxEle: any = null;
    if (checkBoxRef.current)
      checkBoxEle = checkBoxRef.current.querySelector("input[type=checkbox]");
    if (!checkBoxEle) return;
    if (onCheckArgs?.length)
      onCheck(
        checkBoxEle,
        isParent ? !checkBoxEle.checked : checkBoxEle.checked,
        ...onCheckArgs
      );
    else onCheck(checkBoxEle);
  };

  const comp: any =
    label === "search" ? (
      <ListItem
        className={`${classes.checkListItem} ${classes.filterTerms}`}
        // onClick={selectAllClicked}
        data-testid="selectall-fltr-items-bolck"
      >
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            id="autoCompleteSearch"
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput
            }}
            value={searchVal}
            inputProps={{ "aria-label": "search" }}
            onChange={e => {
              setSearchVal(e.target.value);
              onSearchInput(e.target.value);
            }}
            // onKeyUp={getSearchValue}
          />
        </div>
        <div
          className={classes.clearIcon}
          onClick={event => {
            setSearchVal("");
            onSearchInput("");
          }}
        >
          <ClearIcon />
        </div>
      </ListItem>
    ) : (
      <ListItem
        className={`${classes.checkListItem} ${classes.filterTerms}`}
        onClick={event => itemClicked(event, true)}
        data-testid={checkBoxDataTestId}
        style={listItemsStyle}
      >
        <Checkbox
          ref={checkBoxRef}
          checked={checked}
          value={value}
          name={type}
          disableRipple
          style={{
            padding: "0px",
            cursor: "pointer",
            margin: "1px 10px 0px"
          }}
          onClick={itemClicked}
          // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          //   if (onCheckArgs?.length) onCheck(event, ...onCheckArgs);
          //   else onCheck(event);
          // }}
        />
        {label}
        {typeof docCount === "number" ? ` (${docCount})` : null}
      </ListItem>
    );
  return comp;
};

export interface CheckListFilterSectionProps {
  sectionHeader: string;
  hideSectionHeader?: boolean;
  toggleSection: (arg0: string) => void;
  open: boolean;
  checklistItems: CheckListItemProps[];
  onCheck: (...args: any[]) => void;
  onCheckArgs?: any[];
  toggelBtnDataTestId?: string;
  itemListDataTestId?: string;
  onSearch?: any;
  sectionStyles?: {
    block?: any;
    list?: any;
  };
  filterOutterContainer?: string;
}

export const CheckListFilterSection = (props: CheckListFilterSectionProps) => {
  const {
    sectionHeader,
    hideSectionHeader,
    toggleSection,
    open,
    onCheck,
    onCheckArgs,
    toggelBtnDataTestId,
    itemListDataTestId,
    onSearch,
    sectionStyles,
    checklistItems
  } = props;

  const classes = CLFStyles();
  return (
    <div className={classes.filterContainer}>
      {!hideSectionHeader ? (
        <div className={classes.filterHeader}>
          <Badge
            color="primary"
            variant="dot"
            className="dbFilterBadge"
            invisible={
              !(
                checklistItems.length &&
                checklistItems.some((itm: any) => itm.checked)
              )
            }
          >
            <Typography className={classes.filterHeaderText}>
              {sectionHeader}
            </Typography>
          </Badge>
          <IconButton
            component="span"
            onClick={() => toggleSection(sectionHeader)}
            data-testid={toggelBtnDataTestId || "toggle-bstatus-button"}
          >
            {open ? (
              <RemoveIcon className={classes.iconStyles} />
            ) : (
              <AddIcon className={classes.iconStyles} />
            )}
          </IconButton>
        </div>
      ) : null}
      {open ? (
        <div
          className={classes.categoryBlock}
          style={sectionStyles?.block}
          data-testid={itemListDataTestId || "chx-itms"}
        >
          {checklistItems.map((itemObj: CheckListItemProps, index: number) => {
            if (!itemObj.label) return null;
            return (
              <CheckListItem
                key={`chx_${index}`}
                label={itemObj.label}
                value={itemObj.value}
                type={itemObj.type}
                checked={itemObj.checked}
                docCount={itemObj.docCount}
                onCheck={onCheck}
                onCheckArgs={onCheckArgs}
                checkBoxDataTestId={itemObj.checkBoxDataTestId}
                listItemsStyle={sectionStyles?.list}
                onSearchInput={onSearch}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export interface CheckListGroupFilterProps {
  filterBlockDataTestId?: string;
  filterGroupItems: CheckListFilterSectionProps[];
  containerStyle?: any;
  filterOutterContainer?: string;
}

export const CheckListGroupFilter = (props: CheckListGroupFilterProps) => {
  const {
    filterBlockDataTestId,
    filterGroupItems,
    containerStyle,
    filterOutterContainer
  } = props;
  const classes = CLFStyles();
  return (
    <div
      className={
        filterOutterContainer
          ? `${filterOutterContainer}`
          : `${classes.filterOutterContainer}`
      }
      style={containerStyle}
      data-testid={filterBlockDataTestId || "filter-block"}
    >
      {filterGroupItems.map(
        (item: CheckListFilterSectionProps, index: number) => {
          return (
            <CheckListFilterSection
              key={`grp-chx-${index}`}
              sectionHeader={item.sectionHeader}
              hideSectionHeader={item.hideSectionHeader}
              toggleSection={item.toggleSection}
              onCheck={item.onCheck}
              onCheckArgs={item.onCheckArgs}
              open={item.open}
              checklistItems={item.checklistItems}
              toggelBtnDataTestId={item.toggelBtnDataTestId}
              onSearch={item.onSearch}
              itemListDataTestId={item.itemListDataTestId}
              sectionStyles={item.sectionStyles}
            />
          );
        }
      )}
    </div>
  );
};
